import { Mail, MapPin, Clock } from 'lucide-react'
import { siteConfig } from '@/config/site'
import { socialLinks } from '@/config/social'

export function ContactInfoSection() {
  return (
    <div className="space-y-6 sm:space-y-8">
      <div>
        <h2 className="text-xl font-bold tracking-tight text-fg">
          Direct Channels
        </h2>
        <p className="mt-2 text-sm text-fg-subtle leading-relaxed">
          We operate across local and international time zones. Inquiries are reviewed and addressed by our engineering leadership.
        </p>
      </div>

      <div className="space-y-4 sm:space-y-5">
        {/* Email */}
        <div className="flex items-start gap-3.5">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-surface-2 text-fg">
            <Mail size={18} />
          </div>
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-fg-muted block">
              Inquiries & RFPs
            </span>
            <a
              href={`mailto:${siteConfig.email}`}
              className="text-sm font-medium text-fg hover:underline underline-offset-4 break-all py-0.5 inline-block"
            >
              {siteConfig.email}
            </a>
          </div>
        </div>

        {/* Location */}
        <div className="flex items-start gap-3.5">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-surface-2 text-fg">
            <MapPin size={18} />
          </div>
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-fg-muted block">
              Headquarters
            </span>
            <p className="text-sm font-medium text-fg py-0.5">
              {siteConfig.location}
            </p>
          </div>
        </div>

        {/* Response SLA */}
        <div className="flex items-start gap-3.5">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-surface-2 text-fg">
            <Clock size={18} />
          </div>
          <div>
            <span className="text-xs font-semibold uppercase tracking-wider text-fg-muted block">
              Response SLA
            </span>
            <p className="text-sm text-fg-subtle py-0.5">
              Within 24 business hours
            </p>
          </div>
        </div>
      </div>

      {/* Social / Direct Platforms */}
      <div className="pt-5 sm:pt-6 border-t border-border-subtle">
        <span className="text-xs font-semibold uppercase tracking-wider text-fg-muted block mb-3">
          Network & Profiles
        </span>
        <div className="flex flex-wrap gap-2.5 sm:gap-3">
          {socialLinks.map(({ label, href, icon: Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 min-h-[40px] px-3.5 py-2 rounded-sm bg-surface-2 border border-border-subtle text-xs font-medium text-fg-subtle hover:text-fg hover:border-border active:bg-surface-3 transition-colors"
            >
              <Icon size={15} />
              <span>{label}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  )
}
